import { sumMonetaryValues } from "@common/helpers/monetary";

/**
 * What scheduling these document lines puts on the holding account. Each line
 * moves with its own sign, so a credit line nets against the rest, and apply
 * refuses any other amount.
 */
export function getScheduledLinesAmount(
    lines: ReadonlyArray<{ amount: number }>,
): number {
    return Math.abs(sumMonetaryValues(lines.map((line) => line.amount)));
}
